// extracted by mini-css-extract-plugin
export default {"wrapper":"AgentPage_wrapper__z2NfH","back":"AgentPage_back__c+Bc9","text":"AgentPage_text__5DC7Q","input_box_answer":"AgentPage_input_box_answer__NZ6m1"};